document.addEventListener('DOMContentLoaded', () => {
  const tagSelect = document.querySelector('#blog-navigation-select')
  if(tagSelect){
    tagSelect.addEventListener('change', (event) => {
      window.location = event.target.value
    })
  }
});
